import { topLineFunctions } from "./topline";
import { accordFunctions } from "./accord";
import { paginationFns } from "./pagination";

export const commonFunctions = () => {
  accordFunctions();
  paginationFns();
  topLineFunctions();
};
